import { Box, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { Page } from "../components/Page";
import { LoginForm } from "../features/auth/LoginForm";
import { useResponsive } from "../hooks/useResponsive";
import { PRIMARY } from "themes/colors";

// ----------------------------------------------------------------------

export function LoginPage() {
  const mdUp = useResponsive("up", "md");

  return (
    <Page title="Login | Jaman HP Gas" width="100%">
      <Box sx={{ display: "flex", minHeight: "100vh" }}>

        {/* ── Left decorative panel (desktop only) ── */}
        {mdUp && (
          <Box
            sx={{
              width: { md: "45%", lg: "42%" },
              flexShrink: 0,
              background: `linear-gradient(150deg, ${PRIMARY.darker} 0%, ${PRIMARY.dark} 55%, ${PRIMARY.main} 100%)`,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              p: 6,
              position: "relative",
              overflow: "hidden",
            }}
          >
            {/* Decorative blobs */}
            <Box sx={{ position: "absolute", top: -100, right: -100, width: 340, height: 340, borderRadius: "50%", bgcolor: alpha("#fff", 0.05) }} />
            <Box sx={{ position: "absolute", bottom: -80, left: -80, width: 280, height: 280, borderRadius: "50%", bgcolor: alpha("#fff", 0.05) }} />
            <Box sx={{ position: "absolute", top: "40%", left: -40, width: 160, height: 160, borderRadius: "50%", bgcolor: alpha("#fff", 0.03) }} />

            <Box sx={{ zIndex: 1, textAlign: "center", display: "inline-block" }}>

              <Typography variant="h4" fontWeight={800} color="white" gutterBottom lineHeight={1.2}>
                Jaman HP Gas
              </Typography>
              <Typography
                variant="body1"
                color="white"
                sx={{ opacity: 0.72, maxWidth: 300, mx: "auto", mt: 1, lineHeight: 1.6 }}
              >
                Office management system for tracking sales, connections &amp; agents
              </Typography>

              {/* Divider dots */}
              <Box sx={{ display: "flex", justifyContent: "center", gap: 1, mt: 4 }}>
                {[1, 2, 3].map((i) => (
                  <Box
                    key={i}
                    sx={{
                      width: i === 2 ? 24 : 8,
                      height: 8,
                      borderRadius: 4,
                      bgcolor: alpha("#fff", i === 2 ? 0.9 : 0.4),
                      transition: "width 0.3s",
                    }}
                  />
                ))}
              </Box>
            </Box>
          </Box>
        )}

        {/* ── Right form panel ── */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: "grey.100",
            p: { xs: 2.5, sm: 4 },
          }}
        >
          <Box sx={{ width: "100%", maxWidth: 420 }}>
            {/* Mobile logo */}
            {!mdUp && (
              <Box sx={{ textAlign: "center", mb: 4 }}>

                <Typography variant="h6" fontWeight={700} color="text.primary">
                  Jaman HP Gas
                </Typography>
              </Box>
            )}

            {/* Form card */}
            <Box
              sx={{
                bgcolor: "background.paper",
                borderRadius: 3,
                p: { xs: 3, sm: 4 },
                boxShadow: "0 8px 40px rgba(0,0,0,0.08)",
              }}
            >
              <Typography variant="h5" fontWeight={700} gutterBottom>
                Welcome back
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 3.5 }}>
                Sign in to your account to continue
              </Typography>

              <LoginForm />
            </Box>

            <Typography
              variant="caption"
              color="text.primary"
              align="center"
              display="block"
              sx={{ mt: 3 }}
            >
              Jaman HP Gas &copy; {new Date().getFullYear()} — All rights reserved
            </Typography>
          </Box>
        </Box>
      </Box>
    </Page>
  );
}
